import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import styles from './OpSelect.module.css';
import './stylesheets/op2mise-select.css';
import { Query } from '@syncfusion/ej2-data';
import { useCallback, useRef } from 'react';

const OpSelect = (props) => {
  const {
    // Custom Props
    label,
    errorMessage,
    showLabelAsterisk,
    labelPosition = 'top',
    containerClass = '',

    // SyncFusion Dropdown Props
    id,
    cssClass,
    dataSource,
    fields,
    valueTemplate,
    ...rest
  } = props;

  const dropdownRef = useRef(null);

  const defaultValueTemplate = (data) => (
    <label
      className={`${styles.selectedLabel} select-label text-truncate w-100`}
    >
      {data?.name}
    </label>
  );

  const selectContainerClass = `${styles.opSelectContainer} ${
    labelPosition === 'left' ? styles.leftLabel : styles.topLabel
  } ${containerClass ?? ''}`.trim();

  // Enable `contains` search (default is `startsWith`)
  const onFiltering = useCallback(
    (e) => {
      if (!e) return; // guard against null event

      let query = new Query();

      if (e.text) {
        query = query.where(fields?.text || 'name', 'contains', e.text, true);
      }

      e.updateData(dataSource, query);
    },
    [dataSource, fields]
  );

  // When the user quickly selects an item while typing, the popup closes
  // but Syncfusion's internal debounce timer is still pending.
  // When it fires, filterInput is already null → crash.
  // We cancel the timer here on close before it fires.
  const onClose = useCallback(() => {
    const instance = dropdownRef.current;
    if (!instance) return;

    // Clear Syncfusion's internal debounce timer to prevent
    // performFiltering from running after the popup is closed
    if (instance.debounceTimer) {
      clearTimeout(instance.debounceTimer);
      instance.debounceTimer = null;
    }

    // Call parent's close handler if provided
    rest.close?.();
  }, [rest.close]);

  return (
    <div className={`${label ? selectContainerClass : ''}`}>
      {label && (
        <label className={styles.fieldLabel}>
          {label}
          {showLabelAsterisk && <span>*</span>}
        </label>
      )}
      <DropDownListComponent
        ref={dropdownRef}
        cssClass={`op-select ${cssClass || ''}`}
        dataSource={dataSource}
        fields={fields}
        filtering={onFiltering}
        id={id}
        itemTemplate={(item) => (
          <div title={item.name}>
            <div className="text-truncate">{item.name}</div>
          </div>
        )}
        {...rest}
        close={onClose}
      />
    </div>
  );
};

export default OpSelect;
